import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  ACCOUNT_NAVIGATION,
  ADMIN_ACCOUNT_NAVIGATION,
  BASIC_ACCOUNT_NAVIGATION,
  ROUTES,
} from '../../../assets/constants/strings';
import './style.scoped.scss';
import { FaBars } from 'react-icons/fa';

const LeftNavigation = ({ activePage, isCorporte, isAdmin }) => {
  const [accountNavigationType, setAccountNavigationType] = useState([]);

  useEffect(() => {
    if (isCorporte) {
      if (isAdmin) setAccountNavigationType(ADMIN_ACCOUNT_NAVIGATION);
      else setAccountNavigationType(BASIC_ACCOUNT_NAVIGATION);
    } else setAccountNavigationType(ACCOUNT_NAVIGATION);
  }, [isAdmin, isCorporte]);

  return (
    <React.Fragment>
      <div id='account-nav-mobile'>
        <div className='dropdown'>
          <div
            id='my-account-dropdown'
            data-toggle='dropdown'
            aria-haspopup='true'
            aria-expanded='false'
          >
            <FaBars />
          </div>
          <div className='dropdown-menu dropdown-menu-left p-0'>
            <div className='account-nav m-0'>
              {Object.values(accountNavigationType).map((item, i) => (
                <Link
                  to={ROUTES.MY_ACCOUNT + item.URL}
                  key={i}
                  className={`account-nav__item${
                    activePage && activePage === item.URL ? ' active' : ''
                  }`}
                >
                  <span>{item.NAV}</span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className='account-nav' id='desktop-nav'>
        {Object.values(accountNavigationType).map((item, i) => (
          <Link
            to={ROUTES.MY_ACCOUNT + item.URL}
            key={i}
            className={`account-nav__item${
              activePage && activePage === item.URL ? ' active' : ''
            }`}
          >
            <span>{item.NAV}</span>
          </Link>
        ))}
      </div>
    </React.Fragment>
  );
};

export default LeftNavigation;
